import { useCallback, useMemo } from 'react';

import { Id } from '@vimeo/core/types/generic';

interface ITabsItems {
  id: Id;
}

export function useTabsMapping<T extends ITabsItems>(tabsItems: Array<T>) {
  const indexMap = useMemo(() => {
    return tabsItems.reduce((acc, item, index) => {
      (acc as any)[item.id] = index;

      return acc;
    }, {});
  }, [tabsItems]);

  const getIndexById = useCallback(
    (id: Id) => {
      return (indexMap as any)[id] ?? -1;
    },
    [indexMap],
  );

  const getIdByIndex = useCallback(
    (index: number) => {
      return tabsItems[index]?.id ?? '';
    },
    [tabsItems],
  );

  return {
    map: indexMap,
    getIndexById,
    getIdByIndex,
  };
}
